import React from "react";
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Days from "./Days/Days"
import Timeslots from "./Timeslots/Timeslots"
import { Translation } from 'react-i18next';
import * as actionCreators from "../../../redux/store/actions/index"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

class Disponibility extends React.Component {
  changePage = () => {
    this.props.saveCheckoutInfo({
      day: this.props.day,
      timeSlotId: this.props.timeSlotId
    })
    this.props.history.push("/checkout/data");
  }

  render() {
    const { cart, day, selectTimeslot, timeSlotId } = this.props;
    return (
      <Translation>
        {t =>
          <>
            <div className="container-fluid">
              <Col className="text-center disponibilityInfo">
                <span>{cart?.deliveryMode === "IN_STORE" ? t("instore.availability.title") : t("availability.title")}</span>
              </Col>
            </div>
            <div className="container-fluid">
              <Row className="justify-content-center">
                <Days selectDay={this.props.selectDay} cartId={cart && cart.id} day={day} />
              </Row>
            </div>
            {day && <Timeslots day={day} selectTimeslot={selectTimeslot} cartId={cart && cart.id} />}
            <div className="justify-content-center d-flex">
              <button style={{ marginBottom: "unset" }}
                onClick={this.changePage}
                className={`cta ${day && timeSlotId ? "" : "custom-button-disabled"} `}>
                <span>{t("next")}</span>
              </button>
            </div>
          </>
        }
      </Translation>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    saveCheckoutInfo: (data) => dispatch(actionCreators.saveCheckoutInfo(data))
  };
}

export default withRouter(connect(undefined, mapDispatchToProps)(Disponibility));